import { DragSource } from 'react-dnd'
import React, { Component } from 'react';
import arrowRight from '../../images/right-arrow.svg';
import arrowLeft from '../../images/left-arrow.svg';
import alert from '../../images/alert.svg';


// used for products which are both dragable and variation selectable
const Types = {
	ITEM: 'product'
};
const itemSource = {
	beginDrag(props) {
		const {handle, willOccupyCells} = props.details.productDetails;
		props.addDraggingProductToState({productDetails: props.details})
		// pocket-bottle 2.2 refers to 2 places per row in 2 rows
		props.isDragging(true, willOccupyCells);
		return ({id: props.details.id})
	},

	endDrag(props) {
		props.isDragging(false);
	}
};
function collect(connect, monitor) {
	return {
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging(),
		connectDragPreview: connect.dragPreview()
	}
}

class DragProduct extends Component {
	componentDidMount() {
		this._createDrawableImage();
	}

	_createDrawableImage = () => {
		const img = new Image();
		img.src = this.props.imgSrc;
		img.onload = () => this.props.connectDragPreview(img);
		img.width = img.height = 50;
	}

	_connectDragSource(isDragging, connectDragSource, isLoop, disabled){
		if (disabled) {
			return (
				<div className="item content">
					<div className="disabled-overlay">
						<div className="inner">
							<img src={alert}/>
							<p>This module is too large for the current baseplate</p>
							{/* <button className="btn" onClick={() => {
								let r = window.confirm("Changes you've made will not be saved");
								if (r == true) {
									this.props.resetActiveBaseplateState()
								}
								
							}}>Choose Larger Baseplate?</button> */}
						</div>
					</div>

					<img className={`to-scale ${this.props.type}`} alt="Product Details" style={{
						opacity: isDragging ? 0.1 : 1,
						cursor: 'move'
					}} src={this.props.imgSrc}/>
				</div>			
			)
		}

		else {
			return connectDragSource(
				<div className="item content">
					<img className={`to-scale ${this.props.type}`} alt="Product Details" style={{
						opacity: isDragging ? 0.1 : 1,
						cursor: 'move'
					}} src={this.props.imgSrc}/>
				</div>			
			)
		}
		
	}

	render() {
		this._createDrawableImage();
		const { isDragging, connectDragSource, isLoop, disabled} = this.props;
		return(
			<div className={`selection-item ${isDragging ? 'active' : ''}`}>
				<div className={`product-type ${this.props.isPocket ? 'pocket':''}`}>
					<div className="inner-with-arrows">
						<button className="item arrow-left btn" onClick={() => this.props.renderActiveSelectable('prev', this.props.type)}>
							<img src={arrowLeft} alt="Left" />
						</button>
						
						{this._connectDragSource(isDragging, connectDragSource, isLoop, disabled, )}

						<button className="item arrow-right btn" onClick={() => this.props.renderActiveSelectable('next', this.props.type)}>
							<img src={arrowRight} alt="Right" />
						</button>
					</div>
				</div>
				<p className="title">{this.props.title}</p>
			</div>
		)
	}
}
export default DragSource(Types.ITEM, itemSource, collect)(DragProduct)